import { render, staticRenderFns } from "./downloadCorpusDialog.vue?vue&type=template&id=65070384&scoped=true&"
import script from "./downloadCorpusDialog.vue?vue&type=script&lang=js&"
export * from "./downloadCorpusDialog.vue?vue&type=script&lang=js&"
import style0 from "./downloadCorpusDialog.vue?vue&type=style&index=0&id=65070384&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65070384",
  null
  
)

export default component.exports